import { openCopilotOverlay } from '@/shared/stores/ui';

import type { SourceProposedActionT } from '@/shared/lib';

/**
 * Payload for the PA-completed Rx read-only view.
 *
 * Used in two places:
 *
 * 1. ``PatientPriorAuthsTab`` — the clinician clicks a terminal PA row to
 *    review the Rx that was authorized.
 * 2. :mod:`prior_auth_builder.build_completed_action` on the backend — the
 *    proposed action for an approved PA is routed here via the executor so
 *    the prior auth number is already filled in when the clinician reviews.
 */
export interface PaCompletedRxViewPrefill {
  patientUserId: string;
  priorAuthRecordId: string;
  prescriptionRecordId: string;
  /** DoseSpot's prescription id — used to fetch the live prescription. */
  dosespotPrescriptionId: string;
  authorizationNumber: string | null;
  status: string;
  sourceProposedAction?: SourceProposedActionT;
  /** Payer-adjusted quantity from PAFinalStatus (for partial approvals). */
  approvedQuantity?: string | null;
  /** Payer-adjusted days supply from PAFinalStatus (for partial approvals). */
  approvedDaysSupply?: string | null;
  /** Payer-adjusted refills from PAFinalStatus (for partial approvals). */
  approvedRefills?: string | null;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    priorAuthCompletedRx: PaCompletedRxViewPrefill;
  }
}

/**
 * Open the PA-completed Rx read-only view with its payload.
 */
export function openPaCompletedRxViewOverlay(prefill: PaCompletedRxViewPrefill): void {
  openCopilotOverlay('priorAuthCompletedRx', prefill);
}
